import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../../system/components/ProtectedRoute';
import { UserRoles } from '../../system/types';

// Import des routes des sous-modules
import ListeNoireRoutes from './ListNoire/routes';
import PotentielsParrainagesRoutes from './PotentielsParrainages/routes';
import ParrainagesReconductionsRoutes from './ParrainagesReconductions/routes';
// Définition des permissions requises pour chaque module
const modulePermissions: Record<string, UserRoles[]> = {
    ListeNoire: ['ADMIN', 'USER', 'COLLABORATEUR'],
    PotentielsParrainages: ['ADMIN', 'USER', 'COLLABORATEUR'],
    ParrainagesReconductions: ['ADMIN', 'USER', 'COLLABORATEUR'],
};

/**
 * Centralise les routes de la section "collaborateur"
 */
const CollaborateurRoutes: React.FC = () => {
    // Fonction pour wrapper les routes de chaque module avec ProtectedRoute
    const protectRoutes = (
        routes: React.ReactElement[],
        requiredRoles: UserRoles[]
    ) => {
        return routes.map((route, index) => {
            // Cloner la route existante avec ses props
            return (
                <Route
                    key={`protected-${index}`}
                    path={route.props.path}
                    element={
                        <ProtectedRoute requiredRoles={requiredRoles}>
                            {route.props.element}
                        </ProtectedRoute>
                    }
                />
            );
        });
    };

    // Combinaison des routes protégées
    const allModuleRoutes = [
        ...protectRoutes(ListeNoireRoutes, modulePermissions.ListeNoire),
        ...protectRoutes(
            PotentielsParrainagesRoutes,
            modulePermissions.PotentielsParrainages
        ),
        ...protectRoutes(
            ParrainagesReconductionsRoutes,
            modulePermissions.ParrainagesReconductions
        ),
    ];

    return <Routes>{allModuleRoutes}</Routes>;
};

export default CollaborateurRoutes;
